import React from 'react'
import { QuestionFrame, Question, RadioItems } from 'components/questions'
import { RadioGroup, TextField, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { getQuestionKey } from 'common/utils'


const Question16 = ({num, content}: {num: number, content: string}) => {
  const state = useGlobalState()
  const radioItems = state.scoring.getRadioItems('q16')

  const answerValue = React.useMemo(() => {
    const answer = state.app.getAnswer(16, num)
    return answer !== null ? answer.value : {text: '', radio: ''}
  }, [state.app.answers])

  const update = (field: string, updateValue: string) => {
    const data = {
      ...answerValue
    }
    if (field === 'text') {
      data.text = updateValue
      if (updateValue === '') {
        data.radio = ''
      } else if (data.radio === '') {
        data.radio = radioItems[0].value
      }
    } else if (field === 'radio') {
      data.radio = updateValue
    }
    const valid = data.text !== '' && data.radio == '' ? false : true
    state.app.updateAnswer(16, num, data, valid)
  }

  return (
    <Question num={num} content={content}>
      <Typography variant='body2' sx={{textDecoration: 'underline'}}>{'点検状況'}</Typography>

      <TextField
        label="整備している設備・備品"
        multiline
        rows={4}
        sx={{mt: 2, mb: 1}}
        value={answerValue.text}
        onChange={e => update('text', e.target.value)}
      />
      <Typography variant='caption' color={grey[700]}>※ 整備状況については、入力手引書を参照してください。</Typography>

      { answerValue.text && (
        <RadioGroup row value={answerValue.radio} onChange={(e) => update('radio', (e.target as HTMLInputElement).value)}>
          <RadioItems items={radioItems} />
        </RadioGroup>
      )}
    </Question>
  )
}

export const Q16 = () => {
  const state = useGlobalState()

  const nextPageAction = () => {
    const answers = {
      ...state.app.answers
    }
    for (let num = 1; num <= 7; num++) {
      const answer = state.app.getAnswer(16, num)
      if (answer === null) {
        answers[getQuestionKey(16, num)] = {value: {text: '', radio: ''}, valid: true}
      }
    }
    state.app.setAnswers(answers)
  }

  return (
    <QuestionFrame q={16} nextPageAction={nextPageAction}>
      <Question16 num={1} content={'復旧設備'} />
      <Question16 num={2} content={'避難設備'} />
      <Question16 num={3} content={'情報備品'} />
      <Question16 num={4} content={'衛生備品'} />
      <Question16 num={5} content={'防寒備品'} />
      <Question16 num={6} content={'食料品'} />
      <Question16 num={7} content={'他汎用品'} />

    </QuestionFrame>
  )
}
